import React, { useState, useEffect, memo } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./css/default.css";
import image_logo from "./img/logo_ag.png";
import { jwtDecode } from "jwt-decode";
import { decodeScript } from "../EncryptData";
//import { wait } from "@testing-library/user-event/dist/utils";
//import { decode as base64_decode, encode as base64_encode } from "base-64";

function Index() {
    const navigate = useNavigate();
    const [choicesList, setChoicesList] = useState([]);
    const [selectedId, setSelectedId] = useState(null);
    const [sessionId, setSessionId] = useState(0);
    const [sessionName, setSessionName] = useState("");
    const [times, setTimes] = useState("");
    const [start_time, setStartTime] = useState("");
    const [userss, setUserss] = useState([]);
    const status = "2";
    let users;
    useEffect(() => {
        const token = new URLSearchParams(window.location.search).get("tokens");
        const rawValue = new URLSearchParams(window.location.search).get("id");
        if (token != null) {
            const userInfo = jwtDecode(token);
            users = userInfo;
            console.log("Thông tin người dùng từ JWT:", userInfo);
            window.saveToStorage("user-info", JSON.stringify(userInfo));
            window.indexDB.initDB(userInfo.id).then(); //() => console.log("✅ IndexedDB đã khởi tạo!"));
            navigate("/votes?id="+rawValue);
            setUserss(users);
            getChoicesPeopleList(decodeScript(rawValue));
        } else if (window.getFromStorage("user-info") && window.getFromStorage("user-info") !== "null") {
            navigate("/votes?id="+rawValue);
            users = JSON.parse(window.getFromStorage("user-info"));
            setUserss(users);
            getChoicesPeopleList(decodeScript(rawValue));
        }
        else{
            navigate("/votes_login?id="+rawValue);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleChange = (e) => {
        setSelectedId(Number(e.target.value));
    };
    async function getChoicesPeopleList(session_id = 0) {
        //if (parseInt(session_id + 0) !== 0) {
        const result = await window.fetchWithAuth("vote_sessions/getChoicesPeopleList/"+users.id_staff+"/"+session_id);
        const results = await result.json();
        const kq = results.data;
        if(results.code === 200){
            setChoicesList(results.data);
            if(Object.keys(results.data).length !== 0){
                setSessionId(kq[0].session_id);
                setSessionName(kq[0].session_name);
                setTimes(kq[0].times);
                setStartTime(kq[0].start_time);
            }
        } else {
            setChoicesList([]);
        }
    }
    const handleSubmit = async (e) => {
        e.preventDefault(); // Ngăn reload trang

        if (selectedId === null) {
            alert("⚠️ Vui lòng chọn một phương án trước khi gửi.");
            return;
        }
        // Gửi biểu quyết (ví dụ: gọi API hoặc lưu vào localStorage)
        //console.log("✅ Biểu quyết đã gửi với ID:", selectedId);
        const formData = new FormData();
        formData.append('session_id', sessionId);
        formData.append('vote_data', selectedId);
        formData.append('times', times);
        formData.append('start_time', start_time);
        try {
            // Ví dụ: gọi API đăng nhập
            const response = await window.fetchWithAuth("vote_sessions/vote", {
                method: "POST",
                body: formData,
            });
            const result = await response.json();
            if (result.code === 200) {
                //console.log("✅ Biểu quyết thành công:", result);
                // Có thể chuyển trang hoặc hiển thị thông báo
                toast.success(result.msg);
            } 
            if (result.code === 201 || result.code === 301) {
                //console.warn("❌ Biểu quyết thất bại:", result.message);
                toast.error(result.msg);
            }
        } catch (error) {
            console.error("⚠️ Lỗi khi gửi biểu quyết:", error);
        }
    };
    const CountdownItem = ({ id, initialSeconds, statuss }) => { 
            const start = new Date(start_time);
            const now = new Date();
            //const timeDifferenceInSeconds = Math.floor((now.getTime() - start.getTime()) / 1000);

        const [secondsLeft, setSecondsLeft] = useState(initialSeconds);
        useEffect(() => {
            //setSecondsLeft(initialSeconds);
            // Chuyển đổi chuỗi thời gian sang đối tượng Date
            // // Tính toán số giây chênh lệch giữa thời gian kết thúc và hiện tại
            // // Đảm bảo thời gian hiện tại nằm trong khoảng thời gian của phiên
            const timeDifferenceInSeconds = initialSeconds - (Math.floor((now.getTime() - start.getTime()) / 1000));
            if (now >= start && timeDifferenceInSeconds <= initialSeconds && status === "2") {
                setSecondsLeft(timeDifferenceInSeconds);
            } else if (status === "1"){
                setSecondsLeft(initialSeconds);
            }else {
                setSecondsLeft(0); // Nếu phiên đã kết thúc hoặc chưa bắt đầu
                return;
            }
            if (initialSeconds <= 0) return;
            if (status === "1") return; // không chạy nếu chưa được kích hoạt
            if (status === "3") {
                setSecondsLeft(0);
                return;
            }
            const timer = setInterval(() => {
                //setSecondsLeft(prev => prev - 1);
                setSecondsLeft(prev => {
                    if (prev <= 1) {
                        clearInterval(timer);
                        //ChangeStatus(id,3);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
            return () => clearInterval(timer);
        }, [status, initialSeconds]);
        // 👉 Chuyển đổi sang phút và giây
        const minutes = Math.floor(secondsLeft / 60);
        const seconds = secondsLeft % 60;
        const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

        return (
            <>
                ⏳{formattedTime}
            </>
        );
    };
    return (
        <div className="">
            <div style={{textAlign: "center"}}>
                <span className="title_form1">
                    Chào mừng đến phiên biểu quyết <br/>
                    <label style={{paddingTop: "6px", fontSize: 20}}>{sessionName}</label>
                </span>
                <div className="welcome-text" style={{ marginTop: "5px", fontSize: "16px", fontWeight: "bold", color: "#2c3e50" }}>
                    Họ và tên: {userss?userss.fullName:''} <br />
                    Chức vụ: {userss?userss.position:''}<br />
                    Thời gian còn lại: {status==="2"?(
                                                <CountdownItem key={sessionId} id={selectedId} initialSeconds={times*60} status={status}/>
                                            ):"Hết giờ"}
                </div>
                <form id="voteForm" onSubmit={handleSubmit}>
                   {choicesList.map((itemChoices, key) => (
                        <div key={key} id="vote_data" data-original-title="" data-tooltip="tooltip" className="form-control1" placeholder="" style={{fontSize: "20px"}}>
                            <input type="radio" value={itemChoices.id} checked={selectedId === itemChoices.id} onChange={handleChange} readOnly className="ml-3" /> {itemChoices.name}
                        </div>
                    ))}
                    <button type="submit" style={{fontWeight: "bold"}}>Gửi biểu quyết</button>
                </form>
            </div>
            <div>
                {/* <form onSubmit={(e) => login(e)}>
                    <div className="fadeIn first mb-2 text-primary font-weight-bold h5 mb-4">
                        BIỂU QUYẾT
                    </div>
                    <input type="text" id="login" className="fadeIn second login_input mb-2" defaultValue={email} onChange={(e) => setEmail(e.target.value)} placeholder="Nhập tên đăng nhập" />
                    <br />
                    <input type="password" id="password" className="fadeIn third login_input mb-2" onChange={(e) => setPassword(e.target.value)} placeholder="Nhập mật khẩu" />
                    <br />
                    <button onClick={(e) => login(e)} className="btn fadeIn fourth login_submit btn-primary">
                        <i className="fas fa-sign-in-alt mr-3"></i>
                        <b>Đăng nhập</b>
                    </button>
                </form>
                <span className="text-primary">Hoặc</span>
                <br />
                <button onClick={handleLogin} className="btn fadeIn fourth login_sso btn-danger">
                    <i className="fas fa-sign-in-alt mr-3"></i>
                    Đăng nhập bằng Mail An Giang
                </button> */}
                {/* <button onClick={(e) => login_sso_form_vneid(e)} className="btn fadeIn fourth login_sso btn-info">
                    <i className="fas fa-sign-in-alt mr-3"></i>
                    Đăng nhập bằng tài khoản VNeID
                </button> */}
            </div>
            <ToastContainer />
        </div>
    );
}
export default memo(Index);
